var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscribe-and-save"},[_c('SectionTitle',{staticClass:"text-center",attrs:{"text":"Subscribe & Save"}}),_c('product',{attrs:{"product-id":_vm.productId},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var product = ref.product;
return [(product)?[_c('HeroProduct',{attrs:{"product":product}}),_c('SubscribeWithBenefits',{attrs:{"product":product}})]:_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }